import { useCallback, useEffect, useState } from "react"

export const DRAFT_STORAGE_PREFIX = "stears:profile-setup"

export type ProfileSetupDraft<T> = {
  step: number
  data: T
}

export const useProfileSetupDraft = <T>(storageKey: string) => {
  const [draft, setDraft] = useState<ProfileSetupDraft<T> | null>(null)
  const [restored, setRestored] = useState(false)

  useEffect(() => {
    let saved: ProfileSetupDraft<T> | null = null
    try {
      const stored = window.localStorage.getItem(storageKey)
      if (stored) saved = JSON.parse(stored) as ProfileSetupDraft<T>
    } catch {
      saved = null
    }
    setDraft(saved)
    setRestored(true)
  }, [storageKey])

  const save = useCallback(
    (next: ProfileSetupDraft<T>) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(next))
      } catch {
        return
      }
    },
    [storageKey]
  )

  const clear = useCallback(() => {
    try {
      window.localStorage.removeItem(storageKey)
    } catch {
      return
    }
  }, [storageKey])

  return { draft, restored, save, clear }
}
